
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ImageGalleryComponent from "./ImageGallery.vue";
import ArticleCadPreview from "@/components/ArticleCadPreview.vue";
import ComplainTypes from "../../dtos/IComplainType";
import { ComplaintDto } from "../../dtos/complaintDto";
import { blexonResolutionTypes } from "../../dtos/blexonResolutionType";
import { FertigerComplaintResponseType } from "../../dtos/fertigerComplaintResponseType";
import rules from "@/store/rules";
import httpClient from "@/store/httpClient";
import { getZincCoatingText } from "@/dtos/zincCoating";

@Component({
	components: {
		ImageGalleryComponent,
		ArticleCadPreview,
	},
})
export default class TicketPosition extends Vue {
	@Prop()
	private complaintDto!: ComplaintDto;
	private blexonResolutionTypes: any = blexonResolutionTypes;
	private fertigerResponseTypes: any = [
		{
			name: "Noch nicht definiert",
			value: FertigerComplaintResponseType.Unknown,
		},
		{
			name: "Beanstandung ablehnen",
			value: FertigerComplaintResponseType.Declined,
		},
		{
			name: "Ersatzlieferung",
			value: FertigerComplaintResponseType.AcceptedErsatzlieferung,
		},
		{
			name: "Nacharbeit",
			value: FertigerComplaintResponseType.RequestedNacharbeit,
		},
		{
			name: "Gutschrift",
			value: FertigerComplaintResponseType.Discount,
		},
	];

	private async blexonResolutionChanged() {
		await httpClient().post(
			`Ticket/UpdateComplainResolution?complainId=${this.complaintDto.id}&resolutionType=${this.complaintDto.blexonResolution}`,
			null
		);
		this.$emit("resolutionChanged");
	}

	private getComplainType(value: number) {
		const selectedValue = ComplainTypes.find((t: any) => t.value === value);
		if (selectedValue !== undefined) {
			return selectedValue.text;
		}
		return "";
	}

	private getCurrentDate() {
		return Date.now().toString();
	}

	private getZincCoatingText(zincCoating: any): string {
		return getZincCoatingText(zincCoating);
	}

	private getFinishText(value: number) {
		return this.$store.getters.getPowdercoatingFinishText(value);
	}

	private getStructureText(value: number) {
		return this.$store.getters.getPowdercoatingStructureText(value);
	}
}
